import {
    CircularProgress,
    type CircularProgressProps,
    Stack,
    type StackProps,
    Typography,
    styled
} from '@mui/material';

const contentMarginValues = {
    xsmall: 12,
    small: 24,
    medium: 48,
    large: 72
} as const;

type CenteredStackSpacing = keyof typeof contentMarginValues;

export const CenteredStack = styled(Stack)<{ spacing: CenteredStackSpacing }>`
    align-items: center;
    gap: 4px;
    margin-top: ${({ spacing }) => `${contentMarginValues[spacing]}px`};
    margin-bottom: ${({ spacing }) => `${contentMarginValues[spacing] / 2}px`};
` as typeof Stack;

type NoRecordsProps = StackProps & {
    spacing?: CenteredStackSpacing;
    message: string;
};

export const NoRecords = (props: NoRecordsProps) => {
    const { spacing = 'medium', message, children, ...other } = props;

    return (
        <CenteredStack spacing={spacing} {...other}>
            <Typography mt={1} color="text.secondary">
                {message}
            </Typography>

            {children}
        </CenteredStack>
    );
};

const progressSizeValues = {
    small: '24px',
    medium: '32px',
    large: '48px'
} as const;

type ProgressSize = keyof typeof progressSizeValues;

export type CircularProgressSpacedProps = Omit<CircularProgressProps, 'size'> & {
    spacing?: CenteredStackSpacing;
    size?: ProgressSize;
};

export const CircularProgressSpaced = (props: CircularProgressSpacedProps) => {
    const { spacing = 'medium', size = 'medium', ...other } = props;

    return (
        <CenteredStack spacing={spacing}>
            <CircularProgress size={progressSizeValues[size]} {...other} />
        </CenteredStack>
    );
};
